import { render, staticRenderFns } from "./bigEventManage.vue?vue&type=template&id=621b8a51&scoped=true&"
import script from "./bigEventManage.vue?vue&type=script&lang=js&"
export * from "./bigEventManage.vue?vue&type=script&lang=js&"
import style0 from "./bigEventManage.vue?vue&type=style&index=0&id=621b8a51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b8a51",
  null
  
)

export default component.exports